import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Select from "../../../components/ui/Select";
import OrderStatusBadge from "./OrderStatusBadge";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  updateOrderAgintService,
  getOrdersService,
  getOrdersAgentService,
} from "redux/services/orders_service";
import { toast } from "react-toastify";
import Input from "components/ui/Input";

const OrderDetailsModal = ({ order, onClose }) => {
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();

  const [activeTab, setActiveTab] = useState("details");

  const [newPaymentAmount, setNewPaymentAmount] = useState(
    order?.total_amount || 0
  );

  const [newNotes, setNewNotes] = useState("");

  const [newStatus, setNewStatus] = useState(order.order_status);

  const statusOptions = [
    { value: 1, label: t("not_confirmed") }, // CREATED

    { value: 2, label: t("processing") }, // PREPARED

    { value: 3, label: t("shipped") }, // ON_DELIVERY

    { value: 4, label: t("delivered") }, // DELIVERED
  ];

  const handleStatusUpdate = async () => {
    try {
      await dispatch(
        updateOrderAgintService({
          id: order.id,
          data: {
            order_status: newStatus,
            payment_amount: newPaymentAmount,
            payment_method: 1,
            payment_notes: newNotes!==""?newNotes:"لا يوجد ملاحظات",
          },
        })
      ).then((response) => {
         console.log("response");
        console.log(response?.payload?.data?.success);
        if (response?.payload?.data?.success == true) {
        //  onUpdateOrder();
          onClose();
          toast("تم تغيير الحالة بنجاح");
          dispatch(getOrdersAgentService());
        } else {
          console.log("response?.payload");
          console.log(response?.payload?.response?.data?.errors);
          // تحسين عرض الأخطاء: جمعها في رسالة واحدة بدلاً من toast منفصل لكل خطأ
          let errorMessage = "";
          if (response?.payload?.response?.data?.errors) {
            // جمع كل الأخطاء في مصفوفة واحدة، ثم دمجها في string واحد
            const allErrors = Object.values(
              response?.payload?.response?.data?.errors
            ).flatMap((errorArray) => errorArray); // مصفوفة من كل الرسائل
            errorMessage = allErrors.join("\n"); // فصل بسطر جديد (أو استخدم "، " لفصل بفاصلة)
          } else if (response?.payload?.message) {
            errorMessage = response.payload.message;
          } else {
            errorMessage = "حدث خطأ غير معروف";
          }
          // عرض الرسالة كـ toast واحد
          toast.error(errorMessage);
        }
      });
    } catch (error) {
      console.error("Error updating status:", error);

      // Optionally, show an error message to the user
    }
  };
  const tabs = [
    { id: "details", label: t("orderDetails"), icon: "FileText" },
    { id: "items", label: t("orderItems"), icon: "Package" },
    { id: "shipping", label: t("shippingAddress"), icon: "Truck" },
    { id: "payment", label: t("paymentDetails"), icon: "CreditCard" },
  ];

  const formatPrice = (price) => {
    return new Intl.NumberFormat(i18n.language === "en" ? "en" : "ar", {
      style: "currency",
      currency: "IQD",
      maximumFractionDigits: 0,
    }).format(price);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  /*const handleStatusUpdate = () => {
    console.log("Updating status to:", newStatus);
   
  };*/

  const renderTabContent = () => {
    switch (activeTab) {
      case "details":
        return (
          <div className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Left column */}
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("orderNumber")}
                  </label>
                  <div className="font-mono text-xl font-bold text-gray-900">
                    #{order?.id}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("order_date")}
                  </label>
                  <div className="text-gray-700">
                    {formatDate(order?.created_at)}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("status")}
                  </label>
                  <div className="mt-2">
                    <OrderStatusBadge status={order?.order_status_name} />
                  </div>
                </div>
              </div>

              {/* Right column */}
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("customer")}
                  </label>
                  <div className="text-gray-900 font-semibold">
                    {order?.customer?.first_name} {order?.customer?.last_name}
                  </div>
                  <div className="text-sm text-gray-500">
                    {order?.customer?.email}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("total")}
                  </label>
                  <div className="text-2xl font-extrabold text-gray-900">
                    {formatPrice(order?.total_amount)}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-500">
                    {t("paymentDetails")}
                  </label>
                  <div className="text-gray-700">Credit Card</div>
                </div>
              </div>
            </div>

            {/* Update status */}
            {/* الجزء الجديد لتحديث الحالة والمبلغ والملاحظات */}
            <div className="border-t border-gray-200 pt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Row 1: Select و Input بجانب بعض */}
              <Select
                label={"تحديث الحالة"}
                options={statusOptions}
                value={newStatus}
                onChange={setNewStatus}
              />
              <Input
                label="المبلغ المستلم من الزبون"
                type="number"
                value={newPaymentAmount}
                onChange={(e) =>
                  setNewPaymentAmount(parseFloat(e.target.value) || 0)
                }
                placeholder="أدخل المبلغ"
              />

              {/* Row 2: Textarea للملاحظات، يأخذ العرض الكامل */}
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-foreground mb-2">
                  ملاحظات التحديث
                </label>
                <textarea
                  value={newNotes} // State جديد للملاحظات
                  onChange={(e) => setNewNotes(e.target.value)}
                  rows={3}
                  className="w-full px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  placeholder="أضف ملاحظات للتحديث..."
                />
              </div>

              {/* Row 3: Button في النهاية */}
              <div className="md:col-span-2 flex justify-end">
                <Button
                  variant="primary"
                  onClick={handleStatusUpdate}
                  disabled={newStatus === order.status}
                  className="w-full md:w-auto"
                >
                  {t("updateStatus")}
                </Button>
              </div>
            </div>
          </div>
        );

      case "items":
        return (
          <div className="space-y-6">
            <h4 className="text-lg font-semibold text-gray-900">
              {t("orderItems")} ({order?.items?.length})
            </h4>
            <div className="space-y-4 max-h-[50vh] overflow-y-auto pr-2">
              {order?.items?.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg shadow-sm"
                >
                  <div className="w-14 h-14 bg-primary/20 rounded-md flex items-center justify-center">
                    <Icon name="Package" size={24} className="text-primary" />
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold text-gray-900">
                      {item?.product?.name}
                    </div>
                    <div className="text-sm text-gray-500">
                      {t("quantity_label")}: {item?.quantity}
                    </div>
                  </div>
                  {/*<div className="text-right min-w-[80px]">
                   
                    <div className="font-semibold text-gray-900">{formatPrice(item.price)}</div>
                  </div>*/}
                  <div className="text-right min-w-[100px] font-bold text-gray-900">
                    {formatPrice(item?.product?.price * item?.quantity)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );

      case "shipping":
        return (
          <div className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h4 className="flex items-center space-x-2 text-lg font-semibold text-gray-900 mb-4">
                  <Icon name="MapPin" size={18} className="text-primary" />
                  <span>{t("shippingAddress")}</span>
                </h4>
                <div className="space-y-1 text-gray-700 text-sm">
                  <div className="font-semibold">
                    {order?.first_name} {order?.last_name}
                  </div>
                  <div>{order?.address}</div>
                  <div>{order?.area?.name}</div>
                </div>
              </div>

              {/*   <div>
                <h4 className="flex items-center space-x-2 text-lg font-semibold text-gray-900 mb-4">
                  <Icon name="Truck" size={18} className="text-primary" />
                  <span>{t('shippingDetails')}</span>
                </h4>
                <div className="space-y-3 text-sm text-gray-700">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-500">{t('method')}:</span>
                    <span>Standard Shipping</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-500">{t('cost')}:</span>
                    <span>{formatPrice(order.shipping_price)}</span>
                  </div>
                </div>
              </div>*/}
            </div>
          </div>
        );

      case "payment":
        return (
          <div className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h4 className="flex items-center space-x-2 text-lg font-semibold text-gray-900 mb-4">
                  <Icon name="CreditCard" size={18} className="text-primary" />
                  <span>{t("paymentDetails")}</span>
                </h4>
                <div className="space-y-3 text-sm text-gray-700">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-500">
                      {t("method")}:
                    </span>
                    <span>Credit Card</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-500">
                      {t("status")}:
                    </span>
                    <span>Paid</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-500">
                      {t("amount")}:
                    </span>
                    <span className="font-semibold">
                      {formatPrice(order?.total_amount)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-lg w-1/2 max-w-2xl max-h-[90vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center space-x-4">
            <Icon name="FileText" size={28} className="text-primary" />
            <div>
              <h2 className="text-2xl font-bold text-gray-900">
                {t("orderDetails")}
              </h2>
              <p className="text-sm text-gray-500">#{order?.id}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            aria-label="Close modal"
            className="text-gray-400 hover:text-gray-700 transition"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        {/* Tabs */}
        <nav className="flex border-b border-gray-200 px-6">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-2 py-4 px-3 border-b-4 transition-colors duration-200 ${
                activeTab === tab.id
                  ? "border-green-600 text-green-700 font-semibold"
                  : "border-transparent text-gray-500"
              }`}
            >
              <Icon name={tab.icon} size={18} />
              <span className="text-sm">{tab.label}</span>
            </button>
          ))}
        </nav>

        {/* Content */}
        <div className="p-6 overflow-y-auto flex-1">{renderTabContent()}</div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-4 p-6 border-t border-gray-200 bg-gray-50">
          <Button variant="outline" onClick={onClose}>
            {t("close")}
          </Button>
          {/* <Button
            variant="primary"
            onClick={() => console.log('Print order:', order.id)}
            iconName="Printer"
            iconPosition="left"
          >
            {t('printOrder')}
          </Button>*/}
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsModal;
